<template>
  <div class="header">
    <div class="logo">
      <img src="/static/img/logo_mem.png" alt="">
      <img src="/static/img/logo_per.png" alt="">
    </div>
    <ul class="menu">
      <li>
        <a :href="SyUrl">首页</a>
      </li>
      <li>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            账户设置<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="/per-yonghu">用户信息</el-dropdown-item>
            <el-dropdown-item command="/per_pass">密码修改</el-dropdown-item>
            <el-dropdown-item command="/per_dizhi">收货地址</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </li>
    </ul>
    <div class="user">
      <i class="el-icon-user"></i>
      <router-link to="/per-yonghu">{{username}}</router-link>
      <a href="/Home-login-logout.html" class="sign-out" @click="removeInfo">退出</a>
    </div>
  </div>
</template>

<script>
	import S_store from '../../store/index.js'
  export default {
    name: 'header',
    data() {
      return {
        username: '',
		SyUrl:S_store.state.ROOT_URL
      }
    },
    methods: {
      loc(url) {
        window.location.href = url;
      },
      handleCommand(comm) {
        this.$router.push({
          path: comm
        });
      },
      removeInfo() {
        localStorage.removeItem('username');
        localStorage.removeItem('id');
      }
    },
    mounted() {
      this.username = localStorage.getItem('username');
    }
  }
</script>

<style scoped>
  .header {
    display: flex;
    height: 60px;
    align-items: center;
    min-width: 1000px;
  }

  .header a {
    color: #fff;
  }

  .logo {
    margin-left: 10px;
  }

  .menu {
    display: flex;
    margin-left: 200px;
    margin-right: auto;
  }

  .menu>li,
  .el-dropdown {
    line-height: 60px;
    color: #fff;
    font-size: 16px;
    margin-right: 40px;
  }

  .user {
    color: #fff;
    margin-right: 10px;
  }

  .el-dropdown {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/wrap/Head.vue